import { render, staticRenderFns } from "./channelBanner.vue?vue&type=template&id=1eecc08c&scoped=true"
import script from "./channelBanner.vue?vue&type=script&lang=js"
export * from "./channelBanner.vue?vue&type=script&lang=js"
import style0 from "./channelBanner.vue?vue&type=style&index=0&id=1eecc08c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eecc08c",
  null
  
)

export default component.exports